import ApiService from '@shared/services/api.service';

const endPoint = '/batch_jobs';

const BatchJobService = {
  fetchList: async () => ApiService.get(endPoint),
  fetchDetailsOfBatchBaselineJobById: async (id) => ApiService.get(`${endPoint}/${id}`),
  fetchDetailsOfBatchCrawlJobById: async (id) => ApiService.get(`${endPoint}/crawl/${id}`),
  fetchScreenShot: async (urlId) => ApiService.withLoading().get(`/urls/${urlId}/baseline_screenshot`),
  cancelBatchJob: async (batchJobId) => ApiService.delete(`${endPoint}/${batchJobId}`),
};

export default BatchJobService;
